export const ROLES = {
  PROPIETARIO: 'ROLE_PROPIETARIO',
  EMPLEADO: 'ROLE_EMPLEADO',
}
